import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Provider } from "@shopify/app-bridge-react";
import { Banner, Layout, Page } from "@shopify/polaris";

/**
 * A component to configure App Bridge.
 * @desc A thin wrapper around AppBridgeProvider that provides the following capabilities:
 *
 * 1. Ensures that navigating inside the app updates the host URL.
 * 2. Configures the App Bridge Provider, which unlocks functionality provided by the host.
 *
 * See: https://shopify.dev/apps/tools/app-bridge/react-components
 */
export function AppBridgeProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const history = useMemo(
    () => ({
      replace: (path) => {
        navigate(path, { replace: true });
      },
    }),
    [navigate]
  );

  const routerConfig = useMemo(
    () => ({ history, location }),
    [history, location]
  );

  console.log(location);
  // The host may be present initially, but later removed by navigation.
  // By caching this in state, we ensure that the host is never lost.
  // During the lifecycle of an app, these values should never be updated anyway.
  // Using state in this way is preferable to useMemo.
  // See: https://stackoverflow.com/questions/60482318/version-of-usememo-for-caching-a-value-that-will-never-change
  const [appBridgeConfig] = useState(() => {
    const host = new URLSearchParams(location.search).get("host") ||
      window.__SHOPIFY_DEV_HOST

    window.__SHOPIFY_DEV_HOST = host;
    console.log(process.env.REACT_APP_FORCE_REDIRECT)
    if(process.env.REACT_APP_FORCE_REDIRECT === true)
    {
      console.log("Redirected to shopify admin panel")
      return {
        host,
        apiKey: process.env.REACT_APP_SHOPIFY_API_KEY || "6afe7c626f6ddadc1a0fe8618666367d",
        forceRedirect:  process.env.REACT_APP_FORCE_REDIRECT || true,
      };
    }
    console.log("Not Redirected to shopify admin panel")
    return {
      host,
      apiKey: process.env.REACT_APP_SHOPIFY_API_KEY|| "6afe7c626f6ddadc1a0fe8618666367d",
      forceRedirect: false
    };
  });

  console.log(appBridgeConfig)
  if (!process.env.REACT_APP_SHOPIFY_API_KEY || !appBridgeConfig.host) {
    const bannerProps = !process.env.REACT_APP_SHOPIFY_API_KEY || "6afe7c626f6ddadc1a0fe8618666367d"
      ? {
          title: "Missing Shopify API Key..",
          children: (
            <>
              Your app is running without the SHOPIFY_API_KEY environment
              variable. Please ensure that it is set when running or building
              your React app.
            </>
          ),
        }
      : {
          title: "Missing host query argument",
          children: (
            <>
              Your app can only load if the URL has a <b>host</b> argument.
              Please ensure that it is set, or access your app using the
              Partners Dashboard <b>Test your app</b> feature
            </>
          ),
        };

    return (
      // <Page>
        <Layout>
          <Layout.Section>
            {children}
            <div>
              <Banner {...bannerProps} status="critical" />
            </div>
          </Layout.Section>
        </Layout>
      // </Page>
    );
  }

  return (
    <Provider config={appBridgeConfig} router={routerConfig}>
      {children}
    </Provider>
  );
}
